import { Component } from "@angular/core";

@Component({
    selector: 'app-inicio-auth',
    templateUrl: './inicio-auth.component.html',
    styleUrls: ['./inicio-auth.component.scss'],
    standalone: false
})
export class inicioAuthComponent
{
    constructor()
    {
        
    }
}